import ifWindowWidthLessThan from './ifWindowWidthLessThan'

export const SPECIES_ATLANTIC_SALMON = 'Atlantic salmon'
export const SPECIES_COHO = 'Coho'

export const CAGE_COLOR_UNKNOWN = 'cage-sla-unknown'
export const CAGE_COLOR_LEVEL1 = 'cage-sla-level1'
export const CAGE_COLOR_LEVEL2 = 'cage-sla-level2'
export const CAGE_COLOR_LEVEL3 = 'cage-sla-level3'
export const CAGE_COLOR_LEVEL4 = 'cage-sla-level4'
export const CAGE_COLOR_LEVELX = 'cage-sla-levelX'

export const getRateColor = rate => {
  switch (rate) {
    case 1:
      return CAGE_COLOR_LEVEL1
    case 2:
      return CAGE_COLOR_LEVEL2
    case 3:
      return CAGE_COLOR_LEVEL3
    case 4:
      return CAGE_COLOR_LEVEL4
    case 5:
      return CAGE_COLOR_LEVELX
    default:
      return CAGE_COLOR_UNKNOWN
  }
}

export const getChartsRatio = () =>
  // eslint-disable-next-line no-nested-ternary
  ifWindowWidthLessThan(768) ? 1.1 : ifWindowWidthLessThan(1200) ? 1.5 : 2.0

export const getActiveLocus = (objStructure, id, data) => {
  const locusObj = { ...objStructure }
  const locusList = data.get('locus')

  for (const k in locusList) {
    if (locusList.hasOwnProperty(k)) {
      const locus = locusList[k]

      if (locus.locus_id === id) {
        locusObj.index = k
        locusObj.id = id
        locusObj.locus = locus
      }
    }
  }

  return locusObj
}
